import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/app/node_modules/next-themes/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Geist\",\"arguments\":[{\"variable\":\"--font-geist-sans\",\"subsets\":[\"latin\"]}],\"variableName\":\"geistSans\"}");
;
import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["SessionProviderClient"] */ "/app/src/components/auth/session-provider-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ClientErrorBoundary"] */ "/app/src/components/client-error-boundary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CommandPalette"] */ "/app/src/components/command-palette.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["KeyboardShortcutsHelp"] */ "/app/src/components/keyboard-shortcuts-help.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppNav"] */ "/app/src/components/layout/app-nav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PwaManager"] */ "/app/src/components/pwa-manager.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SipShell"] */ "/app/src/components/softphone/sip-shell.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/src/components/ui/sonner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TrialProvider"] */ "/app/src/lib/trial-context.tsx");
